import { Route } from 'vue-router'

// 直播课
export default [
  {
    path: '/live-course/manual',
    name: 'live_course_manual',
    component: () => import('../../views/liveCourse/Manual.vue'),
  },
  {
    path: '/live-course/course/share',
    name: 'live_course_course_share',
    component: () => import('../../views/liveCourse/CourseShare.vue'),
  },
  {
    path: '/live-course/course/report',
    name: 'live_course_course_report',
    props: (r: Route) => ({ id: r.query.live_record_id }),
    component: () => import('../../views/liveCourse/CourseReport.vue'),
  },
  {
    path: '/live-course/serial-course/intro',
    name: 'live_course_serial_course_intro',
    component: () => import('../../views/liveCourse/SerialCourseIntro.vue'),
  },
  {
    path: '/live-course/serial-course/share',
    name: 'live_course_serial_course_share',
    component: () => import('../../views/liveCourse/SerialCourseShare.vue'),
  },
]
